import styled from '@emotion/styled';
import { Gutter } from '../../../../ui';
import { Section } from '../../../content-sections/ui/components/Section';

export const StyledShortcuts = styled(Section)`
	${Gutter.cssVariableName.horizontal}: 0px;
	${Gutter.cssVariableName.vertical}: 0px;
`;
